import { type ChangeEvent as ReactChangeEvent } from 'react';
import { SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { Colors } from '~/themes/colors';
import { Label } from '../Label';
import { Row } from '../Row';
import type { IFieldValueProps } from './Types';

export const FieldValue = ({
  label,
  value,
  setValue,
  placeholder,
  validation = {},
  customInputStyle = {},
  shouldCapitalize = true,
  shouldTrim = false,
  disableEmoji = false,
  required = false,
  error = false,
  errorStyle = 'default',
  dataCy,
}: IFieldValueProps) => {
  const handleChange = (e: ReactChangeEvent<HTMLInputElement>): void => {
    let inputValue = e.target.value;

    if (disableEmoji) {
      inputValue = inputValue.replace(/\p{Extended_Pictographic}/gu, '');
    }

    if (shouldCapitalize) {
      inputValue = inputValue
      .split(/\s+/)
      .map((word) => {
        if (word.length === 0) return word;
        return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
      })
      .join(' ')
    }

    setValue(inputValue);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (shouldTrim) {
      setValue(e.target.value.trim());
    }
  };

  return (
    <div>
      <Row gap={4}>
        <Label text={label} required={required} />
        {error && errorStyle === 'default' && (
          <SolidExclamationWarningAlertIcon color={colors.warning[500]} />
        )}
      </Row>
      <input
        data-cy={dataCy}
        className="input-field"
        style={{
          margin: 0,
          width: 252,
          ...(error &&
            errorStyle === 'border' && {
              borderWidth: 1.5,
              borderStyle: 'solid',
              borderColor: Colors.error_400,
              backgroundColor: Colors.error_background,
            }),
          ...customInputStyle,
        }}
        type="text"
        value={value}
        placeholder={placeholder || label}
        onChange={handleChange}
        onBlur={handleBlur}
        {...validation}
      />
    </div>
  );
};
